import { useFormContext } from "react-hook-form";
import { FormSalesOrderType } from "../types";
import { Input } from "components";
import { APPROVAL } from "utils";

export function LinkToSalesOrder(props: {
    approvalView?: boolean
}): JSX.Element {

    const { getValues } = useFormContext<FormSalesOrderType>()
    const approval_status = getValues("approval_status")

    return (
        <section className="flex items-end">
            <section className="grow">
                <Input
                    disabled={approval_status !== APPROVAL.PENDING || props.approvalView}
                    label="LINK"
                    defaultValue=""
                />
            </section>
        </section>
    )
}